import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateEarmarkConversionStatusReduxParams } from '~types/feat/approval';

import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmEarmarkApprovalModal.module.scss';

const ConfirmEarmarkApprovalModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateEarmarkConversionStatusModalIsOpen);
    const tempUpdateEarmarkConversion = useAppSelector(state => state.approval.tempUpdateEarmarkConversionState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateEarmarkConversionStatus);
    const error = useAppSelector(state => state.approval.errors.updateEarmarkConversionStatus);

    const getStatus = () => {
        switch (tempUpdateEarmarkConversion.status) {
            case 2: return 'Approve';
            case 3: return 'Reject';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateEarmarkConversionStatusModalIsOpen(open));
    const updateEarmarkConversionStatus = (data: TUpdateEarmarkConversionStatusReduxParams) => dispatch(combinedActions.approvalUpdateEarmarkConversionStatusAttempt(data));

    const handleSubmitClick = () => {
        updateEarmarkConversionStatus(tempUpdateEarmarkConversion);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateEarmarkConversionStatusState());
        }
        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} Earmark Conversion?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error && (
                <Text
                    label={error}
                    isError
                />
            )}
        </Modal>
    );
};

export default ConfirmEarmarkApprovalModal;
